module.exports = __webpack_public_path__ + "../resources/img/new_tooltip.463169cb.png";